String.prototype.phoneFormatted = function () {
    if (this.trim() === "") return "";

    let formattedNumber = this.replace(/\s+/g, ""); 
    if (formattedNumber.startsWith("0") || formattedNumber.startsWith("+")) {
        formattedNumber = formattedNumber.slice(1);
    }
    if (formattedNumber.startsWith("355")) {
        formattedNumber = formattedNumber.slice(3);
    }

    return formattedNumber;
};

export default String.prototype.phoneFormatted;
